angular.element(document).ready(function () {
    window["rangy"].initialized = false;
    if (typeof BF_INFO !== "undefined") {
        bannerFlowUser = BF_INFO; //data;
        data = BF_INFO;

        var account = data.accounts[0];
        var plan = account ? account.plans[0] : null;

        if (plan.planCode != "bf-agency" && plan.planCode != "bf-enterprise") {
            if (!location.host.indexOf("sandbox") && !location.host.indexOf("localhost")) {
                var se = document.createElement("script");
                se.type = "text/javascript";
                se.async = true;
                se.src =
                    "//commondatastorage.googleapis.com/code.snapengage.com/js/db0f8810-ade2-4d00-a884-5baaf0cd51ca.js";
                var done = false;
                se.onload = se.onreadystatechange = function () {
                    if (
                        !done &&
                        (!this.readyState ||
                            this.readyState === "loaded" ||
                            this.readyState === "complete")
                    ) {
                        done = true;
                        SnapABug.setUserEmail(data.user.email);
                    }
                };
                var s = document.getElementsByTagName("script")[0];
                s.parentNode.insertBefore(se, s);
            }
        }
    }
});
